export default __webpack_public_path__ + "static/media/contact.6ed78301.gif";